import React from 'react'
import { useTranslation } from 'react-i18next'
const AppAd = () => {
    const { t } = useTranslation()
    return (
        <div className='py-5 text-white overflow-hidden '>
            <div className=" padding-container  " >
                <div className=' flex justify-between items-stretch padding-container gap-10 xs:flex-col md:flex-row bg-cover bg-center rounded-xl pb-5 pt-10' style={{ backgroundImage: `url('/asset/register-bg.jpg')` }} >
                    <div className='flex-1  relative rounded-lg p-5 overflow-hidden'>
                        <div className=' bg-grayColor/30 backdrop-blur-md  absolute inset-0  z-10'></div>
                        <div className=' relative z-20 h-full w-full'>
                            <h2 data-aos="fade" data-aos-delay="200" className=' text-3xl pb-8 pt-3 text-orangeColor font-bold'>{t("download-app-ad")}</h2>
                            <p data-aos="fade" data-aos-delay="300">{t("download-app-text")}</p>
                            <div className=' flex items-center xs:flex-col sm:flex-row  gap-6 pt-8'>
                                <div className=' h-36 w-36 rounded-lg overflow-hidden'>
                                    <img src="/asset/QR_code.jpeg" alt=""  loading='lazy' className='w-full '/>
                                </div>
                            <div data-aos="fade" data-aos-delay="400" className=' flex flex-col  gap-5'>
                                <a href='https://apps.apple.com/eg/app/libooking/id6754592394' className=' flex-center gap-4 w-fit bg-black py-3 px-5 rounded-lg'>
                                    <div className=' w-8'>
                                        <img className=' w-max' src="/asset/appStore.svg" alt="app-store" loading='lazy' />
                                    </div>
                                    <p className=' text-lg'>Apple Store</p>
                                </a>
                                <a href='https://play.google.com/store/apps/details?id=com.libooking.app' className=' flex-center gap-4 w-fit bg-black py-3 px-5 rounded-lg'>
                                    <div className=' w-8'>
                                        <img className=' w-max' src="/asset/googleplay.svg" alt="app-store" loading='lazy' />
                                    </div>
                                    <p className=' text-lg'>Google Play</p>
                                </a>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div className='flex-1 relative rounded-lg overflow-hidden'>
                        <div className=' bg-gradient-to-t from-[#000000]/90 to-[#B35A02]/90 backdrop-blur-md  absolute inset-0  z-10'></div>
                        <div className=' relative z-20 w-full h-full flex flex-col justify-between items-center gap-5'>
                            <div className=' flex xs:flex-col lg:flex-row gap-5 pt-8'>
                                <a href='https://apps.apple.com/eg/app/libooking/id6754592394' className=' flex-center gap-4 w-fit bg-black py-3 px-5 rounded-lg'>
                                    <div className=' w-8'>
                                        <img className=' w-max' src="/asset/appStore.svg" alt="app-store" loading='lazy' />
                                    </div>
                                    <p className=' text-lg'>Apple Store</p>
                                </a>
                                <a href='https://play.google.com/store/apps/details?id=com.libooking.app'  className=' flex-center gap-4 w-fit bg-black py-3 px-5 rounded-lg'>
                                    <div className=' w-8'>
                                        <img className=' w-max' src="/asset/googleplay.svg" alt="app-store" loading='lazy' />
                                    </div>
                                    <p className=' text-lg'>Google Play</p>
                                </a>
                            </div>
                            <div className=' w-1/2 '>
                                <img className='w-full' src="/asset/iphone2.png" alt="ad-image" loading='lazy' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AppAd